/**
 * TruckerShell (Iteration 12 — N9)
 * 
 * Minimal header for trucker context.
 * Reuses AppBar pattern with simplified content — no drawer toggle, no breadcrumbs.
 * Shows: customer name + logout button.
 */

import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import LogoutIcon from '@mui/icons-material/Logout';

import { useAppSelector, useAppDispatch } from '../../store/hooks';
import { signOut } from '../../store/slices/authSlice';

export default function TruckerShell({ children }) {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const activeCustomer = useAppSelector((state) => state.customer.activeCustomer);

  const handleSignOut = async () => {
    await dispatch(signOut());
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar
        position="static"
        elevation={0}
        sx={{
          backgroundColor: theme.palette.background.paper,
          borderBottom: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              color: theme.palette.text.primary,
            }}
          >
            {activeCustomer?.name || 'Assetrac'}
          </Typography>
          <Button
            color="inherit"
            onClick={handleSignOut}
            startIcon={<LogoutIcon />}
            sx={{
              color: theme.palette.text.secondary,
              textTransform: 'none',
            }}
          >
            Sign Out
          </Button>
        </Toolbar>
      </AppBar>
      <Box sx={{ flex: 1 }}>
        {children}
      </Box>
    </Box>
  );
}
